import api from '../../api'
import { endpoints } from '../../apiCommons'
import localCompany from '../localStorage/localCompany'
import { format, parse } from 'date-fns'

const nnReports = async (sEstadoTarjeta) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.nnReports, {
    params: {
      sEmpresa,
      sEstadoTarjeta,
    },
    headers: { token },
  })
}
const nnReportsExport = async (sEstadoTarjeta, type) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.nnReportsExport, {
    params: {
      sEmpresa,
      sEstadoTarjeta,
      type,
    },
    responseType: 'arraybuffer',
    headers: { token, 'Content-Type': 'blob' },
  })
}
const companyConsumptionReport = async (dDesde, dHasta) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.companyConsumptionReport, {
    params: {
      sEmpresa,
      dDesde,
      dHasta,
    },
    headers: { token },
  })
}
const companyConsumptionExport = async (dDesde, dHasta, type) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.companyConsumptionExport, {
    params: {
      sEmpresa,
      dDesde,
      dHasta,
      type,
    },
    responseType: 'arraybuffer',
    headers: { token, 'Content-Type': 'blob' },
  })
}
const dailyEmployeeRefillsReport = async (nMes, nAnio, bTipificacion) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  const data = localCompany.getUserData()
  return api.get(endpoints.dailyEmployeeRefills, {
    params: {
      sEmpresa,
      nMes,
      nAnio,
      sUsuario: data?.sUsuario,
      bTipificacion: bTipificacion || false,
    },
    headers: { token },
  })
}
const dailyEmployeeRefillsExport = async (nMes, nAnio, bTipificacion, type) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  const data = localCompany.getUserData()
  return api.get(endpoints.dailyEmployeeRefillsExport, {
    params: {
      sEmpresa,
      nMes,
      nAnio,
      sUsuario: data?.sUsuario,
      bTipificacion: bTipificacion || false,
      type,
    },
    responseType: 'arraybuffer',
    headers: { token, 'Content-Type': 'blob' },
  })
}
const OCReport = async (dDesde, dHasta) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.ocReport, {
    params: {
      sEmpresa,
      dDesde,
      dHasta,
    },
    headers: { token },
  })
}
const OCExport = async (dDesde, dHasta, type) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.ocExport, {
    params: {
      sEmpresa,
      dDesde,
      dHasta,
      type,
    },
    responseType: 'arraybuffer',
    headers: { token, 'Content-Type': 'blob' },
  })
}
const refillsReport = (dDesde, dHasta, bPorFacturar, sFactura, sRecarga, headers = {}) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  const params = {
    sEmpresa,
    dDesde: format(parse(dDesde, 'dd-MM-yyyy', new Date()), 'yyyy-MM-dd'),
    dHasta: format(parse(dHasta, 'dd-MM-yyyy', new Date()), 'yyyy-MM-dd'),
    bPorFacturar,
  }
  if (sFactura) params.sFactura = sFactura
  if (sRecarga) params.sRecarga = sRecarga

  return api.get(endpoints.refillReport, {
    params,
    responseType: 'arraybuffer',
    headers: { token, ...headers },
  })
}
const casinoReport = (
  dDesde,
  dHasta,
  nPagina,
  nRegistrosPagina,
  bOmitirPaginacion,
  headers = {},
  onlyInfo = false,
) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  const finalHeader = onlyInfo ? { ...headers } : {}
  const params = onlyInfo
    ? {
        sEmpresa,
        dDesde: format(parse(dDesde, 'dd-MM-yyyy', new Date()), 'yyyy-MM-dd'),
        dHasta: format(parse(dHasta, 'dd-MM-yyyy', new Date()), 'yyyy-MM-dd'),
        nPagina,
        nRegistrosPagina,
        bOmitirPaginacion,
      }
    : {
        sEmpresa,
        dDesde: format(parse(dDesde, 'dd-MM-yyyy', new Date()), 'yyyy-MM-dd'),
        dHasta: format(parse(dHasta, 'dd-MM-yyyy', new Date()), 'yyyy-MM-dd'),
      }
  return api.get(
    onlyInfo ? endpoints.casinoReportInfo : endpoints.casinoReport,
    {
      params,
      responseType: onlyInfo ? 'json' : 'arraybuffer',
      headers: { token, ...finalHeader },
    },
  )
}

const listadoColaboradoresReporte = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.listadoColaboradoresReporte, {
    params: {
      sEmpresa,
    },
    headers: { token },
  })
}

const recargaColaboradoresReporte = async (dDesde, dHasta) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.recargaColaboradoresReporte, {
    params: {
      sEmpresa,
      dDesde,
      dHasta,
    },
    headers: { token },
  })
}

const listadoColaboradoresExport = async (type) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.listadoColaboradoresExport, {
    params: {
      sEmpresa,
      type,
    },
    responseType: 'arraybuffer',
    headers: { token, 'Content-Type': 'blob' },
  })
}

const recargaColaboradoresExport = async (dDesde, dHasta, type) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.recargaColaboradoresExport, {
    params: {
      sEmpresa,
      dDesde,
      dHasta,
      type,
    },
    responseType: 'arraybuffer',
    headers: { token, 'Content-Type': 'blob' },
  })
}

export default {
  nnReports,
  nnReportsExport,
  companyConsumptionReport,
  companyConsumptionExport,
  dailyEmployeeRefillsReport,
  dailyEmployeeRefillsExport,
  OCReport,
  OCExport,
  refillsReport,
  casinoReport,
  listadoColaboradoresReporte,
  recargaColaboradoresReporte,
  listadoColaboradoresExport,
  recargaColaboradoresExport,
}
